import { Button } from "@mui/material";
import { deleteShipmentBox, openDeleteBoxPopup } from "../shipmentItemsSlice";
import { useDispatch, useSelector } from "react-redux";
import { selectShipment } from "../../shipmentSlice";
import { useTranslation } from "react-i18next";

const DeleteShipmentBoxButton = ({ boxID, shipmentID }) => {
    const {t} = useTranslation()
    const dispatch = useDispatch()
    const shipment = useSelector(selectShipment);

    const handleButtonClick = () => {
        console.log("boxID: ", boxID)
        if (!shipment.id || !boxID) {
            return;
        }

        dispatch(
            openDeleteBoxPopup({
                shipmentID: shipment.id,
                boxID: boxID,
            })
        );
    };

    return (
        <Button
            variant="contained"
            sx={{
                color: "white",
                bgcolor: "#dc2626",
                fontSize: "0.7rem",
                ":hover": {
                    bgcolor: "#b91c1c",
                },
                ":focus": {
                    bgcolor: "#b91c1c",
                },
            }}
            onClick={handleButtonClick}
            style={{ padding: "3px 6px" }}
        >
            {t("shipment.items.delete_box_button")}
        </Button>
    );
};

export default DeleteShipmentBoxButton;
